export default "__VITE_PUBLIC_ASSET__85da7332__"